import React, {Component} from 'react';
import axios from 'axios';
import './Complaint.css';
import './Complaintitem.css';
class Complaint extends React.Component {
    constructor(props){
        super(props);
    
    }
    
  render() {
    return <div>
    <div className="container ">

<div className="text-center">

    <h3 className="pt-4">Lorem Epsum Mycomplaint pre defined text</h3>

<div className="big-input mb-2"><input type="text" id="name" class="someclass ins" placeholder="Type in your issue "/></div>
 <div><button type="button" className=" btn-outline-green add-to-select btn btn-curve w-300-h-45 mb-4 inside-line">Upload a photo</button></div>
 </div>
           {/*  <h6  className="green-label res mb-0 ">Resolution</h6>
             <form className="form-inline  ">
            <div className="border-btm-selection seletion-width mb-5">                                                                  
                <select className=" header-space ref">
                    <option value="">Refund</option>
                    <option value="">Refund1</option>
                    <option value="">Refund2</option>
                    <option value="">Refund3</option>
                </select>
            </div>								

    </form> 
    <div className="inline  ml-2 mb-2 mobil-btn2">
    </form>  */}
    <div className="inline mt-2 ml-3 mb-5 mobil-btn2 com-itm-btn ">  
        <button type="button" class="  btnn btn-hover btn-outline-success tag-btn ">Back</button>

        <button type="button" class=" add-to-cart2 btnn tag-btn mb-2 "  >Submit</button>
      </div>




</div>

    </div>
        }
    }
    
    export default Complaint;